
import { Options, Vue } from 'vue-class-component'

@Options({
  name: 'ScannerErrorModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
})
export default class ScannerErrorModal extends Vue {
  visible!: boolean
}
